import React from 'react'
import cn from 'classnames'
import {
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  TextField,
  Typography,
} from '@material-ui/core'

import { SourceOption } from 'components/Sources/components'

export const SourceListItemBase = ({ classes, source: { label, booked = 0, limit, id }, 
  onFocus, onBlur, onChange }) => {
  const higlightClass = booked === limit ? classes.highlight : null

  return (
    <ListItem divider className={cn(classes.container, higlightClass)}>
      <SourceOption sourceId={id} label={label} />
      <ListItemText primary={label} />
      <ListItemSecondaryAction className={classes.actions}>
        <TextField
          className={classes.textField}
          name='booked'
          value={booked}
          onChange={onChange(id)}
          onFocus={onFocus}
          onBlur={onBlur(id, label, limit)}
        />
        <Typography variant='subtitle1' style={{ display: 'inline-block' }}>/</Typography>
        <TextField
          className={classes.textField}
          name='limit'
          value={limit}
          onChange={onChange(id, limit)}
          onFocus={onFocus}
          onBlur={onBlur(id, label)}
        />
      </ListItemSecondaryAction>
    </ListItem>
  )
}



// WEBPACK FOOTER //
// ./src/components/Sources/components/SourceListItem/SourceListItem.js